import React from "react";
import PropTypes from "prop-types";
import SocialMediaLink from "./SocialMediaLink";
import "./ProgramSocialLinks.scss";

export default function ProgramSocialLinks({ program }) {
  const urls = program.external_links;
  const linkClassNames = ["SocialMediaLink"];
  if (urls) {
    return (
      <div className="ProgramSocialLinks">
        {urls.INSTAGRAM && (
          <SocialMediaLink classes={linkClassNames} platform="INSTAGRAM" urls={urls} />
        )}
        {urls.FACEBOOK && (
          <SocialMediaLink classes={linkClassNames} platform="FACEBOOK" urls={urls} />
        )}
        {urls.TWITTER && (
          <SocialMediaLink classes={linkClassNames} platform="TWITTER" urls={urls} />
        )}
        {urls.LINKED_IN && (
          <SocialMediaLink classes={linkClassNames} platform="LINKED_IN" urls={urls} />
        )}
      </div>
    );
  }
  return null;
}

ProgramSocialLinks.propTypes = {
  program: PropTypes.object.isRequired,
};
